import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { locales, rtlLocales } from '../i18n';

export default function LocaleLayout() {
  const { locale } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!locale || !locales.includes(locale as any)) {
      // Preserve the rest of the path + query string when redirecting to /en
      const { pathname, search, hash } = location;
      navigate(`/en${pathname}${search}${hash}`, { replace: true });
      return;
    }
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    document.documentElement.lang = locale;
    document.documentElement.dir = rtlLocales.includes(locale as any) ? 'rtl' : 'ltr';
  }, [locale, i18n, navigate]);

  return (
    <>
      <Outlet />
      {/* Consent UI is the CompliOne widget, loaded from index.html.
          The old hand-rolled <CookieBanner /> was removed when it landed —
          two consent banners on one page is worse than either alone. */}
    </>
  );
}
